import moment from 'moment';
import LaycanValueGetter from './LaycanValueGetter';

const LaycanMonthValueGetter = (params) => {
    var laycan = LaycanValueGetter(params);
    var result =
        laycan && moment(laycan.startDate).isValid()
            ? moment(laycan.startDate).format('MM')
            : null;
    return result;
};

export default LaycanMonthValueGetter;
